import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ClaimTemplateScreen } from 'screens/claim-template';

export default withPermissions(ClaimTemplateScreen, [
  GroupSecurity.ClaimTemplateRead,
]);
